// extracted by mini-css-extract-plugin
module.exports =  {"button":"_0d624b9a27--button--gs5R_","loading":"_0d624b9a27--loading--fC43r","spinner":"_0d624b9a27--spinner--rWSqM"};